// @ts-nocheck

import { map } from 'lodash';
import React from 'react';
import { Switch, Route } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { isLibrary } from '../../lib/useragent';
import routes from '../../routes/betting';
import type { Licence } from '../../types/common';
import DesktopBettingLayoutLeftColumn from '../DesktopBettingLayoutLeftColumn';
import DesktopBettingLayoutMiddleColumn from '../DesktopBettingLayoutMiddleColumn';
import DesktopBettingLayoutRightColumn from '../DesktopBettingLayoutRightColumn';
import DesktopBettingModalLayout from '../DesktopBettingModalLayout';

export const BettingLayoutWrapper = styled.div`
  ${({ $isMultiview }) =>
    $isMultiview
      ? css`
          max-width: 2000px;
        `
      : undefined}

  display: flex;
  align-items: start;
  justify-content: ${!isLibrary ? 'center' : 'flex-start'};
`;

type DesktopBettingLayoutProps = {
  connected: boolean;
  realMoney: boolean;
  handleCloseBetbuilder: () => void;
  handlePanicButtonPress: () => void;
  openExternalLink: () => void;
  isMultiview: boolean;
  licence: Licence;
};

/**
 * Display the main layout for the betting section.
 *
 * @param {boolean} connected Detect if we are connected
 * @param {boolean} isMultiview  Detect if we are on multiview mode
 * @param {licence} licence  The current licence
 * @return {ReactNode}  A styled component wrapper with left, middle and all the necessary modals
 */
const DesktopBettingLayout = ({
  connected,
  realMoney,
  handlePanicButtonPress,
  openExternalLink,
  isMultiview,
  licence,
}: DesktopBettingLayoutProps) => {
  return (
    <BettingLayoutWrapper $isMultiview={isMultiview}>
      {!isMultiview ? <DesktopBettingLayoutLeftColumn /> : null}
      <DesktopBettingLayoutMiddleColumn isMultiview={isMultiview} />
      <DesktopBettingLayoutRightColumn
        isMultiview={isMultiview}
        licence={licence}
        connected={connected}
        realMoney={realMoney}
        handlePanicButtonPress={handlePanicButtonPress}
      />
      <Switch>
        {map(routes, ({ pattern, Tab, exact }, key) => (
          <Route key={key} path={pattern} exact={exact}>
            <Tab />
          </Route>
        ))}
      </Switch>
      <DesktopBettingModalLayout connected={connected} openExternalLink={openExternalLink} licence={licence} />
    </BettingLayoutWrapper>
  );
};

export default React.memo<DesktopBettingLayoutProps>(DesktopBettingLayout);
